import React, { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import LineIcon from 'react-lineicons';
import { isMobile } from 'react-device-detect';
import { useLanguage } from '../context/LanguageContext';

const Header = () => {
    const { lang, setLanguage, d } = useLanguage();
    const [navigationToggler, setNavigationToggler] = useState(false);
    const location = useLocation();

    const isGameRoute = location.pathname === '/game';

    useEffect(() => {
        const handleToggleMenuEvent = () => {
            setNavigationToggler(prev => !prev);
        };
        window.addEventListener('toggle-menu', handleToggleMenuEvent);
        return () => window.removeEventListener('toggle-menu', handleToggleMenuEvent);
    }, []);

    const handleNavigationToggler = () => {
        setNavigationToggler(!navigationToggler);
    };

    const toggleLanguage = () => {
        setLanguage(lang === 'es' ? 'en' : 'es');
    };

    const hClasses = {
        'head': 'mi-header',
        'toggler': 'mi-header-toggler',
        'inner': 'mi-header-inner',
        'imagebg': 'mi-header-imagebg',
        'image': 'mi-header-image',
        'menu': 'mi-header-menu',
        'copyright': 'mi-header-copyright'
    };

    const hmClasses = {
        'head': 'mi-header-mobile',
        'toggler': 'mi-header-mobile-toggler',
        'inner': 'mi-header-mobile-inner',
        'imagebg': 'mi-header-mobile-imagebg',
        'image': 'mi-header-mobile-image',
        'menu': 'mi-header-mobile-menu',
        'copyright': 'mi-header-mobile-copyright'
    };

    const h = isMobile ? hmClasses : hClasses;

    return (
        <div> 
            {navigationToggler ? <div onClick={handleNavigationToggler} className="mi-header-transparent"/> : null}
            <nav className={navigationToggler ? h.head + " is-visible" : h.head }>
                {!isGameRoute && (
                    <button onClick={handleNavigationToggler} className={h.toggler} aria-label="Toggle navigation">
                        {!navigationToggler ? <LineIcon name="menu" /> : <LineIcon name="close" />}
                    </button>
                )}
                <div className={h.inner}>
                    <div className={h.image}>
                        <img className={h.imagebg} src={d.information.headerBg} alt="header"/>
                        <Link to="/">
                            <img src={d.information.headerImage} alt="myImage"/>
                        </Link>
                    </div>
                    <span className={h.copyright}>
                        <button onClick={toggleLanguage} className="btn-lang-toggle">
                            {lang === 'es' ? 'English' : 'Español'}
                        </button>
                    </span>
                    
                    <ul className={h.menu}>
                        <li><NavLink to="/"><span>{d.menu.home}</span></NavLink></li>
                        <li><NavLink to="/about"><span>{d.menu.about}</span></NavLink></li>
                        <li><NavLink to="/resume"><span>{d.menu.resume}</span></NavLink></li>
                        <li><NavLink to="/contact"><span>{d.menu.contact}</span></NavLink></li>
                        <div className="menu-divider"/>
                        <li><NavLink to="/apps"><span>Apps</span></NavLink></li>
                        <li><NavLink to="/game"><span className="mi-menu-arcade-glow">Arcade</span></NavLink></li>
                    </ul>
                </div>
            </nav>
        </div>
    );
};

export default Header;